import Model from "../../model"
import { ID, Project } from "../../types"

import Command, { CommandName } from "../command"
import CreateProjectCommand from "./create_project_command"

export type DeleteProjectCommandState = {
  id: ID
  captured?: {
    project: Project
  }
}

export default class DeleteProjectCommand extends Command {
  name: CommandName = "delete-project"
  state: DeleteProjectCommandState

  constructor(state: DeleteProjectCommandState) {
    super()
    this.state = state
  }

  // Possible conflicts:
  //   - project has been deleted already (Cancel)
  resolveConflicts(model: Model): DeleteProjectCommandState | null {
    if (!model.getProject(this.state.id)) return null
    return this.state
  }

  local(model: Model): any {
    this.state.captured = { project: model.fetchProject(this.state.id) }
    model.deleteProject(this.state.id)
  }

  undo(): Command[] {
    if (!this.state.captured) throw "No captured undo state"
    return [
      new CreateProjectCommand({
        id: this.state.id,
        project: this.state.captured.project,
      }),
    ]
  }
}
